/**
 * Created by vladislav on 1/26/2024
 */

const MicrosoftLogic = function () {
    PlatformLogic.call(this);
};

MicrosoftLogic.prototype = Object.create(PlatformLogic.prototype);
MicrosoftLogic.prototype.constructor = MicrosoftLogic;